import React from 'react';
import { Modal, Collapse, Row, Col, Icon, Spin, message } from 'antd';
import Header from '../header';
import wandu from '../../service/wandu';
import env from '../../lib/env';
import styles from './index.css';
import LinesEllipsis from 'react-lines-ellipsis';

const block_size = 100;

const Chapter = ({ is_vip, title }) => (
	<div
		style={{
			padding: '10px 30px',
			fontSize: '14px',
			color: '#666',
			lineHeight: '17px',
			borderBottom: '1px solid #f3f4f5',
			height: '37px',
		}}
	>
		<div style={{ display: 'inline-block', maxWidth: '180px' }}>
			<div>
				<LinesEllipsis text={title.trim()} maxLine={1} />
			</div>
		</div>
		{Number(is_vip) === 1 && <Icon type='lock' style={{ position: 'relative', top: '-2px' }} />}
	</div>
)

export default class Catalog extends React.Component {

	state = {
		blocks: [],
		total: 0,
	}

	load = idx => {
		let block = this.state.blocks[idx];
		if (!block || block.data) {
			return;
		}
		idx = Number(idx);
		this._load(block_size * idx, block_size).then(res => {
			block.data = res.list;
			this.setState({});
		}).catch(e => {
			console.log(e);
		});
	}

	_load = (start, num) => {
		return wandu.book_catalog({
			novel_id: this.props.novel_id,
			start,
			num
		});
	}

	init() {
		this._load(0, block_size).then(res => {
			let blocks = [];
			if (res.count) {
				for (var i = 0; i < res.count; i += block_size) {
					blocks.push({
						start: i + 1,
						end: i + 100,
						data: null,
					});
				}
				blocks[blocks.length - 1].end = res.count;
				blocks[0].data = res.list;
			}
			this.setState({
				total: res.count,
				blocks,
			});
			//从章节列表中找出 可以阅读的最大章节num，交给read组件
			let tempOrderNum = 0;
			res.list.forEach(item => {
				if (item.is_vip == 0) {
					tempOrderNum = Number(item.order_num);
				}
			});
			console.log('Catalog tempOrderNum', tempOrderNum);
			if (tempOrderNum > 0 && this.props.onCallback) {
				this.props.onCallback(tempOrderNum);
			}
		}).catch(e => {
			console.log(e);
		});
	}

	componentDidMount() {
		this.init();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.novel_id !== this.props.novel_id) {
			this.init();
		}
	}

	render() {
		return (
			<Modal
				centered
				width={800}
				bodyStyle={{ padding: '0' }}
				footer={null}
				visible={this.props.show}
				onCancel={this.props.onCancel}
			>
				<Header em title='全部目录' style={{
					padding: '20px 0 0 20px',
				}} />
				<div style={{
					position: 'relative',
					height: '550px',
					overflowY: 'scroll',
				}}>
					<Collapse
						defaultActiveKey={['0']}
						accordion
						onChange={this.load}
						bordered={false}>
						{this.state.blocks.map((block, idx) => (
							<Collapse.Panel
								header={`${block.start}-${block.end}章`}
								key={idx}
								style={{ backgroundColor: '#fafafa' }}>
								{block.data
									? <Row style={{ backgroundColor: '#fff' }}>{block.data.map(item => (
										<Col span={8} key={item.order_num} className={styles.catalog_item} onClick={
											() => {
												if (item.is_vip == 1) {
													message.error('暂不可阅读');
													return;
												}
												env.goto_page(`/book/read/${this.props.novel_id}/${item.order_num}`);
											}}
										>
											<Chapter novel_id={this.props.novel_id} {...item} />
										</Col>
									))}</Row>
									: <div style={{ textAlign: 'center' }}><Spin /></div>
								}
							</Collapse.Panel>
						))}
					</Collapse>
				</div>
			</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/component/catalog/index.js